import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ContactBox from '../components/ContactBox'

const Contact = () => {
    return (
        <>
            <Navbar />
            <ContactBox></ContactBox>
            <Footer />
        </>
    )
}

export default Contact